import { HttpStatusCode } from 'axios';

import { useHttp } from '@/composables';
import { useAuthStore } from '@/store';
import { Role } from '@/const.js';

export default async to => {
  const authStore = useAuthStore();

  if (!authStore.isLoaded && to.meta.requiresAuthentication) {
    authStore.loading = true;

    const response = await useHttp().get('/profile');

    if (response.statusCode === HttpStatusCode.Ok) {
      authStore.user = response.data;

      const currentDistrict = response.data.districts.find(district => district.current);

      /*
             * If the user doesn't have a current district set, redirect them to the district select page.
             * Checking if the user is already on the district select page prevents an infinite redirection.
             */
      if (to.name !== 'app_district_select' && !currentDistrict) {
        return { name: 'app_district_select' };
      }
    }

    authStore.isLoaded = true;
  }

  // The user is authenticated and trying to access a route that they should not be accessing as an authenticated user, such as the login page.
  if (to.meta.requiresAdmin) {
    if (!authStore.user?.roles.includes(Role.Admin)) {
      return { name: 'app_base_authenticated' };
    }
  }

  if (authStore.isAuthenticated) {
    if (to.meta.redirectAuthenticatedUsers) {
      return { name: 'app_base_authenticated' };
    }
  }
  // The user is not authenticated
  else {
    // The user is trying to access a route that requires authentication
    if (to.meta.requiresAuthentication) {
      return { name: 'app_auth_login' };
    }
  }

  authStore.loading = false;
};
